@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.patients.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.patients.generated.resources/"

internal val Res.string.feature_patients_send_reminder: StringResource by lazy {
      StringResource("string:feature_patients_send_reminder", "feature_patients_send_reminder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 66),
      ))
    }

internal val Res.string.patients_add: StringResource by lazy {
      StringResource("string:patients_add", "patients_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77, 44),
      ))
    }

internal val Res.string.patients_default_fee: StringResource by lazy {
      StringResource("string:patients_default_fee", "patients_default_fee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122, 44),
      ))
    }

internal val Res.string.patients_detail_create_recurring_schedule: StringResource by lazy {
      StringResource("string:patients_detail_create_recurring_schedule", "patients_detail_create_recurring_schedule", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167, 81),
      ))
    }

internal val Res.string.patients_detail_delete: StringResource by lazy {
      StringResource("string:patients_detail_delete", "patients_detail_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 54),
      ))
    }

internal val Res.string.patients_detail_delete_cancel: StringResource by lazy {
      StringResource("string:patients_detail_delete_cancel", "patients_detail_delete_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 49),
      ))
    }

internal val Res.string.patients_detail_delete_confirm: StringResource by lazy {
      StringResource("string:patients_detail_delete_confirm", "patients_detail_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 587, 50),
      ))
    }

internal val Res.string.patients_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:patients_detail_delete_confirm_message", "patients_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299, 218),
      ))
    }

internal val Res.string.patients_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:patients_detail_delete_confirm_title", "patients_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 518, 68),
      ))
    }

internal val Res.string.patients_detail_edit_action: StringResource by lazy {
      StringResource("string:patients_detail_edit_action", "patients_detail_edit_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 693, 55),
      ))
    }

internal val Res.string.patients_detail_fee: StringResource by lazy {
      StringResource("string:patients_detail_fee", "patients_detail_fee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 43),
      ))
    }

internal val Res.string.patients_detail_inactive_banner: StringResource by lazy {
      StringResource("string:patients_detail_inactive_banner", "patients_detail_inactive_banner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 793, 115),
      ))
    }

internal val Res.string.patients_detail_log_session: StringResource by lazy {
      StringResource("string:patients_detail_log_session", "patients_detail_log_session", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 909, 59),
      ))
    }

internal val Res.string.patients_detail_no_data: StringResource by lazy {
      StringResource("string:patients_detail_no_data", "patients_detail_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 969, 35),
      ))
    }

internal val Res.string.patients_detail_no_sessions: StringResource by lazy {
      StringResource("string:patients_detail_no_sessions", "patients_detail_no_sessions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1005, 51),
      ))
    }

internal val Res.string.patients_detail_owed: StringResource by lazy {
      StringResource("string:patients_detail_owed", "patients_detail_owed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1057, 36),
      ))
    }

internal val Res.string.patients_detail_partial_amount: StringResource by lazy {
      StringResource("string:patients_detail_partial_amount", "patients_detail_partial_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1094, 54),
      ))
    }

internal val Res.string.patients_detail_phone: StringResource by lazy {
      StringResource("string:patients_detail_phone", "patients_detail_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1149, 41),
      ))
    }

internal val Res.string.patients_detail_recurring_schedules: StringResource by lazy {
      StringResource("string:patients_detail_recurring_schedules", "patients_detail_recurring_schedules", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1191, 71),
      ))
    }

internal val Res.string.patients_detail_register_payment: StringResource by lazy {
      StringResource("string:patients_detail_register_payment", "patients_detail_register_payment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 60),
      ))
    }

internal val Res.string.patients_detail_session_item: StringResource by lazy {
      StringResource("string:patients_detail_session_item", "patients_detail_session_item", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1324, 52),
      ))
    }

internal val Res.string.patients_detail_sessions: StringResource by lazy {
      StringResource("string:patients_detail_sessions", "patients_detail_sessions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1436, 44),
      ))
    }

internal val Res.string.patients_detail_sessions_count: StringResource by lazy {
      StringResource("string:patients_detail_sessions_count", "patients_detail_sessions_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1377, 58),
      ))
    }

internal val Res.string.patients_detail_status_paid: StringResource by lazy {
      StringResource("string:patients_detail_status_paid", "patients_detail_status_paid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1481, 43),
      ))
    }

internal val Res.string.patients_detail_status_partial: StringResource by lazy {
      StringResource("string:patients_detail_status_partial", "patients_detail_status_partial", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1525, 50),
      ))
    }

internal val Res.string.patients_detail_status_pending: StringResource by lazy {
      StringResource("string:patients_detail_status_pending", "patients_detail_status_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1576, 50),
      ))
    }

internal val Res.string.patients_detail_status_waived: StringResource by lazy {
      StringResource("string:patients_detail_status_waived", "patients_detail_status_waived", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1627, 49),
      ))
    }

internal val Res.string.patients_detail_stop_schedule_confirm: StringResource by lazy {
      StringResource("string:patients_detail_stop_schedule_confirm", "patients_detail_stop_schedule_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1677, 57),
      ))
    }

internal val Res.string.patients_detail_stop_schedule_error: StringResource by lazy {
      StringResource("string:patients_detail_stop_schedule_error", "patients_detail_stop_schedule_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1735, 83),
      ))
    }

internal val Res.string.patients_detail_stop_schedule_message: StringResource by lazy {
      StringResource("string:patients_detail_stop_schedule_message", "patients_detail_stop_schedule_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1819, 173),
      ))
    }

internal val Res.string.patients_detail_stop_schedule_title: StringResource by lazy {
      StringResource("string:patients_detail_stop_schedule_title", "patients_detail_stop_schedule_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1993, 79),
      ))
    }

internal val Res.string.patients_detail_this_month: StringResource by lazy {
      StringResource("string:patients_detail_this_month", "patients_detail_this_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2073, 46),
      ))
    }

internal val Res.string.patients_detail_title: StringResource by lazy {
      StringResource("string:patients_detail_title", "patients_detail_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2120, 57),
      ))
    }

internal val Res.string.patients_detail_type_double: StringResource by lazy {
      StringResource("string:patients_detail_type_double", "patients_detail_type_double", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2178, 43),
      ))
    }

internal val Res.string.patients_detail_type_final: StringResource by lazy {
      StringResource("string:patients_detail_type_final", "patients_detail_type_final", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2222, 42),
      ))
    }

internal val Res.string.patients_detail_type_first: StringResource by lazy {
      StringResource("string:patients_detail_type_first", "patients_detail_type_first", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2265, 46),
      ))
    }

internal val Res.string.patients_detail_type_regular: StringResource by lazy {
      StringResource("string:patients_detail_type_regular", "patients_detail_type_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2312, 48),
      ))
    }

internal val Res.string.patients_detail_waive_cancel: StringResource by lazy {
      StringResource("string:patients_detail_waive_cancel", "patients_detail_waive_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2361, 48),
      ))
    }

internal val Res.string.patients_detail_waive_confirm: StringResource by lazy {
      StringResource("string:patients_detail_waive_confirm", "patients_detail_waive_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2410, 65),
      ))
    }

internal val Res.string.patients_detail_waive_message: StringResource by lazy {
      StringResource("string:patients_detail_waive_message", "patients_detail_waive_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2476, 153),
      ))
    }

internal val Res.string.patients_detail_waive_title: StringResource by lazy {
      StringResource("string:patients_detail_waive_title", "patients_detail_waive_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2630, 55),
      ))
    }

internal val Res.string.patients_edit_title: StringResource by lazy {
      StringResource("string:patients_edit_title", "patients_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2686, 47),
      ))
    }

internal val Res.string.patients_email_label: StringResource by lazy {
      StringResource("string:patients_email_label", "patients_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2734, 36),
      ))
    }

internal val Res.string.patients_empty_subtitle: StringResource by lazy {
      StringResource("string:patients_empty_subtitle", "patients_empty_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2771, 83),
      ))
    }

internal val Res.string.patients_empty_title: StringResource by lazy {
      StringResource("string:patients_empty_title", "patients_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2855, 48),
      ))
    }

internal val Res.string.patients_error_fee_invalid: StringResource by lazy {
      StringResource("string:patients_error_fee_invalid", "patients_error_fee_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2904, 78),
      ))
    }

internal val Res.string.patients_error_limit_reached: StringResource by lazy {
      StringResource("string:patients_error_limit_reached", "patients_error_limit_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2983, 108),
      ))
    }

internal val Res.string.patients_error_load_failed: StringResource by lazy {
      StringResource("string:patients_error_load_failed", "patients_error_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3092, 70),
      ))
    }

internal val Res.string.patients_error_name_required: StringResource by lazy {
      StringResource("string:patients_error_name_required", "patients_error_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3163, 68),
      ))
    }

internal val Res.string.patients_error_phone_required: StringResource by lazy {
      StringResource("string:patients_error_phone_required", "patients_error_phone_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3232, 69),
      ))
    }

internal val Res.string.patients_error_save_failed: StringResource by lazy {
      StringResource("string:patients_error_save_failed", "patients_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3302, 74),
      ))
    }

internal val Res.string.patients_fee_label: StringResource by lazy {
      StringResource("string:patients_fee_label", "patients_fee_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3377, 58),
      ))
    }

internal val Res.string.patients_fee_placeholder: StringResource by lazy {
      StringResource("string:patients_fee_placeholder", "patients_fee_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3436, 40),
      ))
    }

internal val Res.string.patients_form_title: StringResource by lazy {
      StringResource("string:patients_form_title", "patients_form_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3477, 51),
      ))
    }

internal val Res.string.patients_list_title: StringResource by lazy {
      StringResource("string:patients_list_title", "patients_list_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3529, 39),
      ))
    }

internal val Res.string.patients_mark_paid_cancel: StringResource by lazy {
      StringResource("string:patients_mark_paid_cancel", "patients_mark_paid_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3569, 45),
      ))
    }

internal val Res.string.patients_mark_paid_confirm: StringResource by lazy {
      StringResource("string:patients_mark_paid_confirm", "patients_mark_paid_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3615, 46),
      ))
    }

internal val Res.string.patients_mark_paid_error: StringResource by lazy {
      StringResource("string:patients_mark_paid_error", "patients_mark_paid_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3662, 80),
      ))
    }

internal val Res.string.patients_mark_paid_method_cash: StringResource by lazy {
      StringResource("string:patients_mark_paid_method_cash", "patients_mark_paid_method_cash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3743, 50),
      ))
    }

internal val Res.string.patients_mark_paid_method_mercadopago: StringResource by lazy {
      StringResource("string:patients_mark_paid_method_mercadopago", "patients_mark_paid_method_mercadopago", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3794, 61),
      ))
    }

internal val Res.string.patients_mark_paid_method_transfer: StringResource by lazy {
      StringResource("string:patients_mark_paid_method_transfer", "patients_mark_paid_method_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3856, 62),
      ))
    }

internal val Res.string.patients_mark_paid_success_many: StringResource by lazy {
      StringResource("string:patients_mark_paid_success_many", "patients_mark_paid_success_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3919, 71),
      ))
    }

internal val Res.string.patients_mark_paid_success_one: StringResource by lazy {
      StringResource("string:patients_mark_paid_success_one", "patients_mark_paid_success_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3991, 62),
      ))
    }

internal val Res.string.patients_mark_paid_title: StringResource by lazy {
      StringResource("string:patients_mark_paid_title", "patients_mark_paid_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4054, 52),
      ))
    }

internal val Res.string.patients_name_label: StringResource by lazy {
      StringResource("string:patients_name_label", "patients_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4107, 39),
      ))
    }

internal val Res.string.patients_notes_label: StringResource by lazy {
      StringResource("string:patients_notes_label", "patients_notes_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4147, 36),
      ))
    }

internal val Res.string.patients_notes_placeholder: StringResource by lazy {
      StringResource("string:patients_notes_placeholder", "patients_notes_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4184, 70),
      ))
    }

internal val Res.string.patients_phone_label: StringResource by lazy {
      StringResource("string:patients_phone_label", "patients_phone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4255, 44),
      ))
    }

internal val Res.string.patients_phone_placeholder: StringResource by lazy {
      StringResource("string:patients_phone_placeholder", "patients_phone_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4300, 50),
      ))
    }

internal val Res.string.patients_save: StringResource by lazy {
      StringResource("string:patients_save", "patients_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4351, 45),
      ))
    }

internal val Res.string.patients_session_anchor_date_label: StringResource by lazy {
      StringResource("string:patients_session_anchor_date_label", "patients_session_anchor_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4397, 66),
      ))
    }

internal val Res.string.patients_session_date_label: StringResource by lazy {
      StringResource("string:patients_session_date_label", "patients_session_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4464, 43),
      ))
    }

internal val Res.string.patients_session_error_create_failed: StringResource by lazy {
      StringResource("string:patients_session_error_create_failed", "patients_session_error_create_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4508, 112),
      ))
    }

internal val Res.string.patients_session_error_fee_invalid: StringResource by lazy {
      StringResource("string:patients_session_error_fee_invalid", "patients_session_error_fee_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4621, 102),
      ))
    }

internal val Res.string.patients_session_error_interval_invalid: StringResource by lazy {
      StringResource("string:patients_session_error_interval_invalid", "patients_session_error_interval_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4724, 87),
      ))
    }

internal val Res.string.patients_session_fee_label: StringResource by lazy {
      StringResource("string:patients_session_fee_label", "patients_session_fee_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4812, 46),
      ))
    }

internal val Res.string.patients_session_frequency_biweekly: StringResource by lazy {
      StringResource("string:patients_session_frequency_biweekly", "patients_session_frequency_biweekly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4859, 55),
      ))
    }

internal val Res.string.patients_session_frequency_custom: StringResource by lazy {
      StringResource("string:patients_session_frequency_custom", "patients_session_frequency_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4915, 61),
      ))
    }

internal val Res.string.patients_session_frequency_label: StringResource by lazy {
      StringResource("string:patients_session_frequency_label", "patients_session_frequency_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4977, 56),
      ))
    }

internal val Res.string.patients_session_frequency_monthly: StringResource by lazy {
      StringResource("string:patients_session_frequency_monthly", "patients_session_frequency_monthly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5034, 54),
      ))
    }

internal val Res.string.patients_session_frequency_weekly: StringResource by lazy {
      StringResource("string:patients_session_frequency_weekly", "patients_session_frequency_weekly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5089, 53),
      ))
    }

internal val Res.string.patients_session_interval_days_label: StringResource by lazy {
      StringResource("string:patients_session_interval_days_label", "patients_session_interval_days_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5143, 68),
      ))
    }

internal val Res.string.patients_session_kind_one_off: StringResource by lazy {
      StringResource("string:patients_session_kind_one_off", "patients_session_kind_one_off", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5212, 45),
      ))
    }

internal val Res.string.patients_session_kind_recurring: StringResource by lazy {
      StringResource("string:patients_session_kind_recurring", "patients_session_kind_recurring", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5258, 55),
      ))
    }

internal val Res.string.patients_session_section_title: StringResource by lazy {
      StringResource("string:patients_session_section_title", "patients_session_section_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5314, 58),
      ))
    }

internal val Res.string.patients_session_type_double: StringResource by lazy {
      StringResource("string:patients_session_type_double", "patients_session_type_double", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5373, 44),
      ))
    }

internal val Res.string.patients_session_type_final: StringResource by lazy {
      StringResource("string:patients_session_type_final", "patients_session_type_final", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5418, 43),
      ))
    }

internal val Res.string.patients_session_type_first: StringResource by lazy {
      StringResource("string:patients_session_type_first", "patients_session_type_first", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5462, 47),
      ))
    }

internal val Res.string.patients_session_type_label: StringResource by lazy {
      StringResource("string:patients_session_type_label", "patients_session_type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5510, 55),
      ))
    }

internal val Res.string.patients_session_type_regular: StringResource by lazy {
      StringResource("string:patients_session_type_regular", "patients_session_type_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5566, 49),
      ))
    }

internal val Res.string.patients_skip_action: StringResource by lazy {
      StringResource("string:patients_skip_action", "patients_skip_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5616, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_patients_send_reminder", Res.string.feature_patients_send_reminder)
  map.put("patients_add", Res.string.patients_add)
  map.put("patients_default_fee", Res.string.patients_default_fee)
  map.put("patients_detail_create_recurring_schedule", Res.string.patients_detail_create_recurring_schedule)
  map.put("patients_detail_delete", Res.string.patients_detail_delete)
  map.put("patients_detail_delete_cancel", Res.string.patients_detail_delete_cancel)
  map.put("patients_detail_delete_confirm", Res.string.patients_detail_delete_confirm)
  map.put("patients_detail_delete_confirm_message", Res.string.patients_detail_delete_confirm_message)
  map.put("patients_detail_delete_confirm_title", Res.string.patients_detail_delete_confirm_title)
  map.put("patients_detail_edit_action", Res.string.patients_detail_edit_action)
  map.put("patients_detail_fee", Res.string.patients_detail_fee)
  map.put("patients_detail_inactive_banner", Res.string.patients_detail_inactive_banner)
  map.put("patients_detail_log_session", Res.string.patients_detail_log_session)
  map.put("patients_detail_no_data", Res.string.patients_detail_no_data)
  map.put("patients_detail_no_sessions", Res.string.patients_detail_no_sessions)
  map.put("patients_detail_owed", Res.string.patients_detail_owed)
  map.put("patients_detail_partial_amount", Res.string.patients_detail_partial_amount)
  map.put("patients_detail_phone", Res.string.patients_detail_phone)
  map.put("patients_detail_recurring_schedules", Res.string.patients_detail_recurring_schedules)
  map.put("patients_detail_register_payment", Res.string.patients_detail_register_payment)
  map.put("patients_detail_session_item", Res.string.patients_detail_session_item)
  map.put("patients_detail_sessions", Res.string.patients_detail_sessions)
  map.put("patients_detail_sessions_count", Res.string.patients_detail_sessions_count)
  map.put("patients_detail_status_paid", Res.string.patients_detail_status_paid)
  map.put("patients_detail_status_partial", Res.string.patients_detail_status_partial)
  map.put("patients_detail_status_pending", Res.string.patients_detail_status_pending)
  map.put("patients_detail_status_waived", Res.string.patients_detail_status_waived)
  map.put("patients_detail_stop_schedule_confirm", Res.string.patients_detail_stop_schedule_confirm)
  map.put("patients_detail_stop_schedule_error", Res.string.patients_detail_stop_schedule_error)
  map.put("patients_detail_stop_schedule_message", Res.string.patients_detail_stop_schedule_message)
  map.put("patients_detail_stop_schedule_title", Res.string.patients_detail_stop_schedule_title)
  map.put("patients_detail_this_month", Res.string.patients_detail_this_month)
  map.put("patients_detail_title", Res.string.patients_detail_title)
  map.put("patients_detail_type_double", Res.string.patients_detail_type_double)
  map.put("patients_detail_type_final", Res.string.patients_detail_type_final)
  map.put("patients_detail_type_first", Res.string.patients_detail_type_first)
  map.put("patients_detail_type_regular", Res.string.patients_detail_type_regular)
  map.put("patients_detail_waive_cancel", Res.string.patients_detail_waive_cancel)
  map.put("patients_detail_waive_confirm", Res.string.patients_detail_waive_confirm)
  map.put("patients_detail_waive_message", Res.string.patients_detail_waive_message)
  map.put("patients_detail_waive_title", Res.string.patients_detail_waive_title)
  map.put("patients_edit_title", Res.string.patients_edit_title)
  map.put("patients_email_label", Res.string.patients_email_label)
  map.put("patients_empty_subtitle", Res.string.patients_empty_subtitle)
  map.put("patients_empty_title", Res.string.patients_empty_title)
  map.put("patients_error_fee_invalid", Res.string.patients_error_fee_invalid)
  map.put("patients_error_limit_reached", Res.string.patients_error_limit_reached)
  map.put("patients_error_load_failed", Res.string.patients_error_load_failed)
  map.put("patients_error_name_required", Res.string.patients_error_name_required)
  map.put("patients_error_phone_required", Res.string.patients_error_phone_required)
  map.put("patients_error_save_failed", Res.string.patients_error_save_failed)
  map.put("patients_fee_label", Res.string.patients_fee_label)
  map.put("patients_fee_placeholder", Res.string.patients_fee_placeholder)
  map.put("patients_form_title", Res.string.patients_form_title)
  map.put("patients_list_title", Res.string.patients_list_title)
  map.put("patients_mark_paid_cancel", Res.string.patients_mark_paid_cancel)
  map.put("patients_mark_paid_confirm", Res.string.patients_mark_paid_confirm)
  map.put("patients_mark_paid_error", Res.string.patients_mark_paid_error)
  map.put("patients_mark_paid_method_cash", Res.string.patients_mark_paid_method_cash)
  map.put("patients_mark_paid_method_mercadopago", Res.string.patients_mark_paid_method_mercadopago)
  map.put("patients_mark_paid_method_transfer", Res.string.patients_mark_paid_method_transfer)
  map.put("patients_mark_paid_success_many", Res.string.patients_mark_paid_success_many)
  map.put("patients_mark_paid_success_one", Res.string.patients_mark_paid_success_one)
  map.put("patients_mark_paid_title", Res.string.patients_mark_paid_title)
  map.put("patients_name_label", Res.string.patients_name_label)
  map.put("patients_notes_label", Res.string.patients_notes_label)
  map.put("patients_notes_placeholder", Res.string.patients_notes_placeholder)
  map.put("patients_phone_label", Res.string.patients_phone_label)
  map.put("patients_phone_placeholder", Res.string.patients_phone_placeholder)
  map.put("patients_save", Res.string.patients_save)
  map.put("patients_session_anchor_date_label", Res.string.patients_session_anchor_date_label)
  map.put("patients_session_date_label", Res.string.patients_session_date_label)
  map.put("patients_session_error_create_failed", Res.string.patients_session_error_create_failed)
  map.put("patients_session_error_fee_invalid", Res.string.patients_session_error_fee_invalid)
  map.put("patients_session_error_interval_invalid", Res.string.patients_session_error_interval_invalid)
  map.put("patients_session_fee_label", Res.string.patients_session_fee_label)
  map.put("patients_session_frequency_biweekly", Res.string.patients_session_frequency_biweekly)
  map.put("patients_session_frequency_custom", Res.string.patients_session_frequency_custom)
  map.put("patients_session_frequency_label", Res.string.patients_session_frequency_label)
  map.put("patients_session_frequency_monthly", Res.string.patients_session_frequency_monthly)
  map.put("patients_session_frequency_weekly", Res.string.patients_session_frequency_weekly)
  map.put("patients_session_interval_days_label", Res.string.patients_session_interval_days_label)
  map.put("patients_session_kind_one_off", Res.string.patients_session_kind_one_off)
  map.put("patients_session_kind_recurring", Res.string.patients_session_kind_recurring)
  map.put("patients_session_section_title", Res.string.patients_session_section_title)
  map.put("patients_session_type_double", Res.string.patients_session_type_double)
  map.put("patients_session_type_final", Res.string.patients_session_type_final)
  map.put("patients_session_type_first", Res.string.patients_session_type_first)
  map.put("patients_session_type_label", Res.string.patients_session_type_label)
  map.put("patients_session_type_regular", Res.string.patients_session_type_regular)
  map.put("patients_skip_action", Res.string.patients_skip_action)
}
